"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreneedContractType = void 0;
var PreneedContractType;
(function (PreneedContractType) {
    PreneedContractType["NotApplicable"] = "NotApplicable";
    PreneedContractType["Insurance"] = "Insurance";
    PreneedContractType["Trust"] = "Trust";
})(PreneedContractType = exports.PreneedContractType || (exports.PreneedContractType = {}));
//# sourceMappingURL=preneed-contract-type.js.map